<div class="wrapper" [style.min-width]="minWidth | async">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
